/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CaseLengths {
  None = 0,
  Short = 1,
  Long = 2,
}
